import React, { JSX, useContext, useMemo } from "react";
import Image from "next/image";
import { AppContext } from "context/app";
import { convertFromCentsToDollars } from "@pepdirect/v3/helpers/currency";
import { endpoints } from "config";
import { getCloudflareLoader } from "@pepdirect/v3/helpers/cloudflareImages";

import st from "./shippingBadge.module.scss";

// TODO: Extract to separate component with BundlePromo
export function ShippingBadge(): JSX.Element {
  const { tenant } = useContext(AppContext);
  const freeShippingThreshold = useMemo(() => {
    return convertFromCentsToDollars(
      tenant?.shippingConfig.freeShippingThreshold || 0,
      "$0,0"
    );
  }, [tenant?.shippingConfig.freeShippingThreshold]);

  return (
    <div className={st.wrapper}>
      <figure className={st.imageWrapper}>
        <Image
          loader={getCloudflareLoader(endpoints.cdn)}
          src="/static-images/pantry-shop-icons/free-ship-badge.png"
          alt="free ship badge"
          fill
          // double width for retina screens
          sizes="120px"
          style={{
            objectFit: "contain",
          }}
        />
      </figure>

      <div className={st.text}>
        <strong>Free Standard Shipping Over {freeShippingThreshold}</strong> on
        all orders with most orders arriving in 2-4 business days.
      </div>
    </div>
  );
}
